import React from 'react';
import { Button, Modal } from 'react-bootstrap';

interface PropsModalMessage {
  title: string;
  message: string;
  handleConfirme: () => void;
  showMessage: boolean;
  setShowMessage: React.Dispatch<React.SetStateAction<boolean>>;
}

const ModalMessage = ({
  title,
  message,
  handleConfirme,
  showMessage,
  setShowMessage,
}: PropsModalMessage): JSX.Element => {
  return (
    <div>
      <Modal show={showMessage} onHide={() => setShowMessage(false)} centered>
        <Modal.Body>
          <div className="d-flex flex-column">
            <p className="fw-bold" style={{ fontWeight: '600' }}>
              {title}
            </p>
            <p style={{ color: '#828282' }}>{message}</p>
            <div className="d-flex justify-content-end">
              <Button
                className="button-popup-secundary"
                onClick={() => setShowMessage(false)}
              >
                cancelar
              </Button>
              <Button className="button-popup-primary" onClick={handleConfirme}>
                confirmar
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ModalMessage;
